import React, { useEffect, useState } from "react";
import "./MySurveys.scss";
import { Select } from "components/form";
import { IoIosSearch } from "react-icons/io";
import { Dropdown, ProgressBar } from "react-bootstrap";
import { HiDotsVertical } from "react-icons/hi";
import { calendarIcon, usersIcon } from "assets/icons";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  charLimit,
  getValueOrFallback,
  isArrayEmpty,
  isFalse,
  isTrue,
} from "utils/commonHelper";
import { deleteSelectedSurveyApi, surveyListApi } from "services/survey";
import { getFromLocal } from "config/axiosInstance";
import { toastMessage } from "utils/toastMessageHelper";
import { calculateSurveyCompletion } from "utils/surveyHelper";
import { formattedDateMMMDDYYYY } from "utils/dateHelper";
import useShimmer from "hooks/useShrimmer";
import MySurveyShrimmer from "../../../shrimmer/Survey/MySurveyShrimmer";
import { handleEncryptionParams } from "utils/dataCipherHelper";
import CustomModal from "components/modals/CustomModal";
import ExtendSurveyDate from "./ExtendSurveyDate";
import DeleteModal from "components/modals/DeleteModal";
import PublistSurveyModel from "../createSurvey/publishSurvey/PublistSurveyModel";
import useDebounce from "hooks/useDebounce";
import { SURVEY_STATUS_LIST } from "constant/staticData";
import NotFoundPlaceHolder from "components/not-found/NotFoundPlaceHolder";
import { surveyPlaceholderImg } from "assets/images";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";

const MySurveys = () => {
  // set all value
  const navigateTo = useNavigate();

  const [surveyList, setSurveyList] = useState([]);
  const [totalSurvey, setTotalSurvey] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const surveyStatus = searchParams.get("surveyStatus") || "";
  const [surveyExtendDate, setSurveyExtendDate] = useState(false);
  const [deleteSelectedSurvey, setDeleteSelectedSurvey] = useState(false);
  const [publishSelectedSurvey, setPublishSelectedSurvey] = useState(false);
  const [selectedSurveyDetail, setSelectedSurveyDetail] = useState({});
  const [deleteSurveyLoader, setDeleteSurveyLoader] = useState(false);
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
  const [surveyActivePage, setSurveyActivePage] = useState(1);
  const [isUpdate, setIsUpdate] = useState(false);

  // hooks
  const [showShimmer, setShowShimmer] = useShimmer(MySurveyShrimmer);
  const { t } = useTranslation();

  // handle all function

  // Close model
  const closeModel = () => {
    setSurveyExtendDate(false);
    setDeleteSelectedSurvey(false);
    setPublishSelectedSurvey(false);
    setSelectedSurveyDetail("");
  };

  // Survey Status Handler
  const surveyStatusHandler = (surveyStatusValue) => {
    if (surveyStatusValue === "" || !surveyStatusValue) {
      searchParams.delete("surveyStatus");
    } else {
      searchParams.set("surveyStatus", surveyStatusValue);
    }
    setSearchParams(searchParams);
  };

  // delete survey handler
  const selectedSurveyDeletehandler = (surveyDetail) => {
    setSelectedSurveyDetail(surveyDetail);
    setDeleteSelectedSurvey(true);
  };

  // publish survey handler
  const selectedSurveyPublishhandler = (surveyDetail) => {
    setSelectedSurveyDetail(surveyDetail);
    setPublishSelectedSurvey(true);
  };

  // Fetch Survey List Handler
  const fetchSurveyListHandler = async () => {
    try {
      setShowShimmer(true);
      const reqData = {
        token: getFromLocal(),
        limit: 9,
        page: surveyActivePage,
      };

      if (search && debouncedValue) {
        reqData.search = debouncedValue;
      }

      if (surveyStatus) {
        reqData.surveyStatus = surveyStatus;
      }
      const responseData = await surveyListApi(reqData);
      const {
        data: { surveyList = [], total = 0 },
        message = "",
        status,
      } = responseData;
      if (status === 200) {
        if (Number(surveyActivePage) === 1) {
          setSurveyList(surveyList);
          // toastMessage(message, "success", "SurveyList");
        } else {
          setSurveyList((prevList) => [...prevList, ...surveyList]);
        }
        // setSurveyList(surveyList);

        setTotalSurvey(total);
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setShowShimmer(false);
    }
  };

  // Survey Delete handler
  const surveydeleteHandler = async () => {
    try {
      setDeleteSurveyLoader(true);
      const reqData = {
        surveyId: selectedSurveyDetail?._id,
        token: getFromLocal(),
      };
      const responseData = await deleteSelectedSurveyApi(reqData);
      const { message = "", status } = responseData;
      if (status === 200) {
        toastMessage(message, "success", "deleteSelectedSurvey");
        setSurveyList((prev) =>
          prev.filter((survey) => survey._id !== selectedSurveyDetail?._id)
        );
        closeModel();
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setDeleteSurveyLoader(false);
    }
  };

  // Params handler
  const surveyParamsHandler = (survey) => {
    if (survey?.surveyStatus === "draft") {
      reDirectHandler(survey);
      // } else if (isTrue(survey?.isCompleted) && isFalse(survey?.publishSurvey)) {
      //   const paramsData = {
      //     stepper: 5,
      //     isDraft: false,
      //     surveyId: survey?._id,
      //   };
      //   const encryptedParams = handleEncryptionParams(paramsData, searchParams);
      //   setSearchParams(encryptedParams);
      //   navigateTo(`/dashboard/create-survey?${encryptedParams}`);
    } else {
      const paramsData = { surveySlug: survey?._id };
      const encryptedParams = handleEncryptionParams(paramsData, searchParams);
      setSearchParams(encryptedParams);
      navigateTo(`/dashboard/surveys/feedback?${encryptedParams}`);
    }
  };

  // Load More
  const loadMore = () => {
    if (surveyList.length < totalSurvey) {
      setSurveyActivePage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    fetchSurveyListHandler();
  }, [debouncedValue, searchParams, surveyActivePage]);

  // Function for re-direct on survey page
  const reDirectHandler = (data) => {
    const paramsData = {
      stepper: 3,
      isDraft: true,
      surveyId: data?._id,
    };
    const encryptedParams = handleEncryptionParams(paramsData, searchParams);

    // return;
    setSearchParams(encryptedParams);
    navigateTo(`/dashboard/create-survey?${encryptedParams}`);
  };

  const renderSurveyList = (index, survey) => {
    return (
      <div
        key={index}
        className="item"
        onClick={() => setSelectedSurveyDetail(survey)}
      >
        <div
          className={`surveys_card ${
            isTrue(survey?.isCompleted)
              ? isTrue(survey?.publishSurvey)
                ? "ongoing"
                : "private"
              : survey?.surveyStatus
          }`}
        >
          <div className="head">
            <p onClick={() => surveyParamsHandler(survey)}>
              <span>{`${getValueOrFallback(
                survey?.surveyReferenceNumber
              )}`}</span>
              <b>{charLimit(getValueOrFallback(survey?.title), 18)}</b>
            </p>
            <Dropdown className="customDropdown">
              <Dropdown.Toggle id="dropdown-basic">
                <HiDotsVertical />
              </Dropdown.Toggle>
              {["draft", "completed"].includes(survey?.surveyStatus) ? (
                <Dropdown.Menu>
                  <Dropdown.Item
                    className="delete"
                    onClick={() => selectedSurveyDeletehandler(survey)}
                  >
                    {t(`SURVEYLIST.deleteSurveyTitle`)}
                  </Dropdown.Item>
                </Dropdown.Menu>
              ) : isTrue(survey?.isCompleted) &&
                isTrue(survey?.publishSurvey) ? (
                <Dropdown.Menu>
                  {survey?.surveytype === "free" && (
                    <Dropdown.Item
                      className="delete"
                      onClick={() => selectedSurveyDeletehandler(survey)}
                    >
                      {t(`SURVEYLIST.deleteSurveyTitle`)}
                    </Dropdown.Item>
                  )}
                  <Dropdown.Item onClick={() => setSurveyExtendDate(true)}>
                    {t(`SURVEYLIST.editExpiryDate`)}
                  </Dropdown.Item>
                </Dropdown.Menu>
              ) : (
                <Dropdown.Menu>
                  <Dropdown.Item
                    className="delete"
                    onClick={() => selectedSurveyDeletehandler(survey)}
                  >
                    {t(`SURVEYLIST.deleteSurveyTitle`)}
                  </Dropdown.Item>
                </Dropdown.Menu>
              )}
            </Dropdown>
          </div>
          <div
            className="survey_content"
            onClick={() => surveyParamsHandler(survey)}
          >
            <p>{charLimit(getValueOrFallback(survey?.description), 100)}</p>
            <ul className="survey_duration">
              <li>
                <span>{t(`SURVEYLIST.surveyDuration`)}</span>{" "}
                <strong>
                  {getValueOrFallback(survey?.duration)} {t(`SURVEYLIST.min`)}
                </strong>
              </li>
              <li>
                <span>{t(`SURVEYLIST.totalAmount`)}</span>{" "}
                <strong>
                  {survey?.surveytype === "paid"
                    ? `${getValueOrFallback(
                        Number(survey?.userCount || 0) *
                          Number(survey?.rewardPerPerson || 0)
                      )} SAR`
                    : "0 SAR"}
                </strong>
              </li>
            </ul>

            <div className="progress_wrap">
              <span>
                {calculateSurveyCompletion(
                  Number(survey?.userCount) || 0,
                  Number(survey?.totalParticipants) || 0
                )}{" "}
                %
              </span>
              <ProgressBar
                now={calculateSurveyCompletion(
                  Number(survey?.userCount) || 0,
                  Number(survey?.totalParticipants) || 0
                )}
              />
            </div>

            <ul className="participants">
              <li>
                <img src={calendarIcon} alt="" />{" "}
                <span>
                  {formattedDateMMMDDYYYY(
                    getValueOrFallback(survey?.expiryDate)
                  )}
                </span>
              </li>
              <li>
                <img src={usersIcon} alt="" />{" "}
                <span>
                  {survey?.totalParticipants}/{survey?.userCount}{" "}
                  {t(`SURVEYLIST.participant`)}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  };

  const scrollToTop = () => {
    const scrollContainer = document.querySelector(
      ".infinite-scroll-component"
    );
    if (scrollContainer) {
      scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
    }
    // setSurveyActivePage(1);
  };

  return (
    <>
      <div className="my_surveys">
        <h3 className="dashboard_title">
          {t(`SURVEYLIST.totalSurvey`)} <span>{totalSurvey || 0}</span>
        </h3>
        <div className="has_child">
          <div className="search_wrap">
            <input
              type="search"
              placeholder={t(`SURVEYLIST.search`)}
              className="input form-control"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <span className="search_icon">
              <IoIosSearch />
            </span>
          </div>
          <Select
            className="filter"
            value={surveyStatus || ""}
            onChange={(e) => surveyStatusHandler(e.target.value)}
          >
            {SURVEY_STATUS_LIST?.map(({ label, key, value }, index) => (
              <option value={value} key={`${key}-${index}`}>
                {t(`SURVEYLIST.${label}`)}
              </option>
            ))}
          </Select>
        </div>
        {/* <div className="card_wrap">
          {surveyActivePage === 1 && showShimmer ? (
            showShimmer
          ) : !isArrayEmpty(surveyList) ? (
            <Virtuoso
              data={surveyList}
              style={{ height: "600px", width: "100%" }}
              totalCount={surveyList.length + (showShimmer ? 3 : 0)}
              endReached={loadMore}
              footer={() => showShimmer} 
              item={(index) => {
                const surveyValue = surveyList[index];
                if (surveyValue) {
                  return renderSurveyList(index, surveyValue);
                }
                return null;
              }}
            />
          ) : (
            <NotFoundPlaceHolder
              title="Survey list not found"
              placeHolderImage={usersIcon}
              className="mySurveyList"
            />
          )}
        </div> */}
        <InfiniteScroll
          // height={450}
          dataLength={surveyList?.length || 0}
          next={() => setSurveyActivePage((prev) => prev + 1)}
          hasMore={surveyList?.length < totalSurvey}
          loader={<div className="card_wrap">{showShimmer}</div>}
          // inverse={true}
          endMessage={
            Number(surveyActivePage) > 1 && (
              <p
                style={{ textAlign: "center", cursor: "pointer" }}
                onClick={scrollToTop}
              >
                <b>{t(`SURVEYLIST.noMoreSurvey`)}</b>
              </p>
            )
          }
        >
          {" "}
          <div className="card_wrap">
            {!isArrayEmpty(surveyList) && surveyList.length > 0 ? (
              surveyList.map((surveyValue, index) =>
                renderSurveyList(index, surveyValue)
              )
            ) : (
              <NotFoundPlaceHolder
                title={t(`SURVEYLIST.surveyListNotFound`)}
                placeHolderImage={surveyPlaceholderImg}
                className="mySurveyList"
              />
            )}
          </div>
        </InfiniteScroll>
      </div>

      {/* Extend Survey Date Model */}
      {surveyExtendDate && (
        <CustomModal
          show={surveyExtendDate}
          handleClose={closeModel}
          className={"extendsurveymodel"}
        >
          <ExtendSurveyDate
            // isUpdate={isUpdate}
            isListUpdated={true}
            handleClose={closeModel}
            setIsUpdate={setIsUpdate}
            setSurveyList={setSurveyList}
            surveyId={selectedSurveyDetail?._id}
          />
        </CustomModal>
      )}

      {/* Delete Survey Handler */}
      {deleteSelectedSurvey && (
        <DeleteModal
          show={deleteSelectedSurvey}
          handleClose={closeModel}
          className={"deleteSurvey"}
          deleteHandler={surveydeleteHandler}
          title={t(`SURVEYLIST.deleteSurveyDescription`)}
          loader={deleteSurveyLoader}
        />
      )}

      {/* Publish Selected Survey */}
      {publishSelectedSurvey && (
        <CustomModal
          show={publishSelectedSurvey}
          handleClose={closeModel}
          className={""}
        >
          <PublistSurveyModel
            handleClose={closeModel}
            selectedSurveyId={selectedSurveyDetail?._id}
            setSurveyList={setSurveyList}
            isListUpdated={true}
          />
        </CustomModal>
      )}
    </>
  );
};

export default MySurveys;
